import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {EventLogFilters} from "@/pages/maintenance/maintenance-dashboard/tabs/schedule-eventlog/EventLogTable/components/EventLogFilters.tsx";
import {MaintenanceEventLogExport} from "@/pages/maintenance/maintenance-dashboard/tabs/schedule-eventlog/EventLogTable/components/MaintenanceEventLogExport.tsx";

interface EventLogControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const EventLogControlBar = ({search, setSearch, filterSets, onFilterSetChange}: EventLogControlBarProps) => {
  return (
    <ActionBarWrapper
      className="mb-3"
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant="tableControlBar" />
          <EventLogFilters filterSets={filterSets} onFilterSetChange={onFilterSetChange} />
        </>
      }
      right={<MaintenanceEventLogExport />}
    />
  );
};
